import { Calendar } from './calendar.component';

export * from './calendar.component';
export default Calendar;

Calendar.define('der-ui-calendar');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-calendar': Calendar;
    }
}
